import './Selector.css'
import stickers from '../assets/constants/stickers.js';
import React from "react"

function StickerSelector(props) {

    return (
                        <div className="displaysOnShelfDiv">
                        {stickers.map((display, index) => (
                            <div className="vaseSelector" key={index}>
                                {props.selectedSticker === index &&
                                <div className="selectedStickerHighlight"></div>
                                }
                                <img className="stickerDisplay" onClick={() => props.setSelectedSticker(index)} src={display.src} alt={display.alt} />
                            </div>
                        ))}
                    </div>
    )
}

export default StickerSelector;